import { ErrorMessage as HookFormErrorMessage } from '@hookform/error-message'
import classNames from 'classnames'
import React, { forwardRef, LegacyRef, useImperativeHandle, useRef } from 'react'
import { FieldErrors, FieldValues } from 'react-hook-form'
import ErrorMessage from '../ErrorMessage'

interface InputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label?: string
  containerClassName?: string
  labelClassName?: string
  inputClassName?: string
  customOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  errors?: FieldErrors<FieldValues>
}

const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { name, label, type, errors, placeholder, containerClassName, labelClassName, inputClassName, ...inputProps } = props

  const inputRef = useRef<HTMLInputElement>(null)

  useImperativeHandle(ref, () => inputRef.current!)

  return (
    <div className={containerClassName}>
      {label && (
        <label className={labelClassName} htmlFor={name}>
          {label}
        </label>
      )}
      <input
        {...inputProps}
        ref={inputRef as LegacyRef<HTMLInputElement>}
        id={name}
        name={name}
        type={type || 'text'}
        className={classNames('text-KMRS-Darkmode px-5 py-5 max-h-[60px] rounded-3xl bg-KMRS-Light focus:outline-hidden', inputClassName)}
        placeholder={placeholder}
      />
      {errors && name && <HookFormErrorMessage errors={errors} name={name} render={({ message }) => <ErrorMessage message={message} />} />}
    </div>
  )
})

Input.displayName = 'Input'

export default Input
